import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import DatePicker from "react-datepicker";
import axios from "axios";
import { format } from "date-fns";
import "react-datepicker/dist/react-datepicker.css";

// import ParentHeader from "../../parentHeader/ParentHeader";
import images from "../../../utilities/images/images";
import uiActions from "../../../redux/ui/action";
import LoaderPopUp from "../../../components/loader/loader";
import StudentMonthAttendanceContent from "./StudentMonthAttendanceContent" ;

const StudentMonthAttendance = (props) => {
  const { rollNo, startLoading, finishLoading, loginFromParent, loader } = props;

  const [startDate, setStartDate] = useState(() => {
    const now = new Date();
    return new Date(now.getFullYear(), now.getMonth(), 1);
  });
  
  const [endDate, setEndDate] = useState(new Date());
  const [attendanceData, setAttendanceData] = useState({});

  const getAttendanceDetails = async () => {
    const payload = {
      startDate: format(startDate, "yyyy-MM-dd"),
      endDate: format(endDate, "yyyy-MM-dd"),
      rollNo: rollNo,
    };

    startLoading();

    try {
      const response = await axios.post(
        "https://bg.mescray001.com/api/v1/zoom-attendance/get-student-attendance-monthwise-mla",
        payload,
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      if (response.status === 200 && response.data) {
        setAttendanceData(response.data);
      } else {
        setAttendanceData({});
      }
    } catch (error) {
      console.error("API Error:", error);
      setAttendanceData({});
    } finally {
      finishLoading();
    }
  };

  return (
    <>
      {loginFromParent}
      <div className="student-activity-wrapper">
        <div className="container_grey_box">
          <div className="bckBtn-title">
            <Link className="backBtn" to="/parent-dashboard">
              <img src={images.m2_backBtn} alt="backBtn" />
            </Link>
            <div className="content-head">
              <h1>Student Attendance</h1>
            </div>
          </div>

          <div className="range_div">
            <div className="left">
              <p>Data showing from</p>
              <p>Search by specific date</p>
            </div>
            <div className="right">
              <div className="date">
                <p>From</p>
                <DatePicker
                  selected={startDate}
                  onChange={(date) => setStartDate(date)}
                  dateFormat="dd MMM yyyy"
                  maxDate={new Date()}
                />
              </div>
              <div className="date">
                <p>To</p>
                <DatePicker
                  selected={endDate}
                  onChange={(date) => setEndDate(date)}
                  dateFormat="dd MMM yyyy"
                  maxDate={new Date()}
                />
              </div>
              <button onClick={getAttendanceDetails}>Continue</button>
            </div>
          </div>
          <StudentMonthAttendanceContent attendanceData={attendanceData} />
        </div>

        
      </div>

      {loader && <LoaderPopUp />}
    </>
  );
};

const mapStateToProps = (state) => ({
  loader: state.ui.loader,
  rollNo: state.parentrootReducer.parentAuthReducer.user.st_rollno,
  loginFromParent: state.parentrootReducer.parentAuthReducer.loginFromParent,
});

const mapDispatchToProps = (dispatch) => ({
  startLoading: () => dispatch(uiActions.startLoading()),
  finishLoading: () => dispatch(uiActions.finishLoading()),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(StudentMonthAttendance);
